import { ChangeCircleOutlined, ChevronRight } from "@mui/icons-material";
import { Button, Skeleton, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { IconVisit } from "../../../../../components/IconVisit";

type VisitInfoSectionProps = {
    plannerStatus: string;
    protocolName: string;
    protocolVisit: {
        name?: string | null | undefined;
        number: number;
    };
    hasStagedChanges: boolean;
    showReviewToolButton: boolean;
    reviewToolButtonHref: string;
};

export function VisitInfoSection({
    plannerStatus,
    protocolName,
    protocolVisit,
    hasStagedChanges,
    showReviewToolButton,
    reviewToolButtonHref,
}: VisitInfoSectionProps) {
    const { t } = useTranslation("plannerV2");

    return (
        <Stack sx={theme => ({ borderBottom: `1px solid ${theme.palette.divider}`, padding: 2 })} rowGap={2}>
            <Stack direction="row" gap={2}>
                <Stack justifyContent="center" alignItems="center" gap={1}>
                    <IconVisit status={plannerStatus} /> 
                    {hasStagedChanges && <ChangeCircleOutlined color="warning" fontSize="small" />}
                </Stack>
                <Stack flexGrow={1}>
                    <Typography flexGrow={1} variant="body1">
                        {protocolName}
                    </Typography>
                    <Typography flexGrow={1} variant="subtitle2" color="textSecondary">
                        {protocolVisit.name ?? t("visitDetail.visitNumber", { visitNumber: protocolVisit.number })}
                    </Typography>
                </Stack>
            </Stack>
            {showReviewToolButton && (
                <Button variant="outlined" size="small" component={Link} to={reviewToolButtonHref} endIcon={<ChevronRight />}>
                    {t("visitDetail.openInReviewTool")}
                </Button>
            )}
        </Stack>
    );
}

export function VisitInfoSectionSkeleton() {
    return (
        <Stack direction="row" gap={2} sx={theme => ({ borderBottom: `1px solid ${theme.palette.divider}`, padding: 2 })}>
            <Skeleton variant="circular" width={40} height={40} />
            <Stack flexGrow={1} justifyContent="center">
                <Skeleton variant="text" width="70%" height={24} sx={{ marginBottom: 0.5 }} />
                <Skeleton variant="text" width="50%" height={20} />
            </Stack>
        </Stack>
    );
}
